export enum FeedbackStatusEnum {
  POSITIVE= 'a4c740ad-9969-45ad-be6d-aaba276a6dd3',
  NEUTRAL= '1f399a88-158f-440a-935a-7d81bce986ca',
  NEGATIVE= 'a71081ab-207f-457d-be9a-509d01408338'
}
